module.exports = __webpack_public_path__ + "media/images/new-ui-images/reassign-icon-55665edacf4a096edd20331abfe48c40.svg";